/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';
import { IPagination } from '../reducers/PortofolioReducer';
import { TransactionHistoryListItem } from '../reducers/TransactionHistoryReducer';

export const GET_TRANSACTION_HISTORY_LIST = 'GET_TRANSACTION_HISTORY_LIST';
export const SET_TRANSACTION_HISTORY_LIST = 'SET_TRANSACTION_HISTORY_LIST';
export const SUCCESS_SET_TRANSACTION_HISTORY_LIST =
	'SUCCESS_SET_TRANSACTION_HISTORY_LIST';

export interface ITransactionHistoryListResponse {
	transactionHistoryList: TransactionHistoryListItem[];
	pagination: IPagination;
}

export const getTransactionHistoryListAction =
	createAction<TransactionHistoryParamsRequest>(GET_TRANSACTION_HISTORY_LIST);
export const setTransactionHistoryListAction =
	createAction<ITransactionHistoryListResponse>(SET_TRANSACTION_HISTORY_LIST);

export interface TransactionHistoryParamsRequest {
	type: string;
	status: string;
	startDate: string;
	endDate: string;
}
